import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('pagenotes').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithType(type) {
	const { data, error } = await supabase.from('pagenotes').select().eq('type', type)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('pagenotes').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const { data, error } = await supabase.from('pagenotes').select().eq('studentId', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getNotesData(studentId, instructorId, pageName) {
	const { data, error } = await supabase
		.from('pagenotes')
		.select()
		.eq('studentId', studentId)
		//.eq('instructorId', instructorId)
		.eq('page', pageName)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('pagenotes').insert(adata).select()

	console.log('notes error', error, adata)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('pagenotes').update(udata).eq('id', udata.id).select()
	console.log('udata', udata, data, error)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('pagenotes').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
